import {
  Box,
  Flex,
  Link,
  Text,
  useBreakpointValue,
  Tooltip,
  Icon,
  Spinner,
} from "@chakra-ui/react";
import Group from "../../ServicosAcolhimento/Visualizar/Group";
import TableSA from "../../../components/TableSA";
import React, { useState, useEffect } from "react";
import { useAuthProvider } from "../../../../Context/AuthProvider";
import {
  servicoAcolhimentoFunc,
  dashboardFunc,
  Permission,
} from "../../../../helpers/Funcionalidades";
import { Link as ReactLink } from "react-router-dom";
import LoadingSpinner from "../../../components/LoadingSpinner";
import ServicoAcolhimentoService from "../../../../main/services/ServicoAcolhimentoService";
import { handleVerifyRedirectPendenciaServico } from "../../../utils/handleVerifyRedirectPendenciaServico";
import { useHistory } from "react-router-dom";
import SemRegistros from "../../../components/SemRegistros";
import { PopoverGenero } from "../../../components/PopoverGenero";
import { IoHelpCircle } from "react-icons/io5";
import { RiFileExcel2Line } from "react-icons/ri";
import Swal from "sweetalert2";
import RelatorioService from "../../../../main/services/RelatorioService";

export default function DashboardServicoAcolhimentoPendencia() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const { roleKeycloack, user, selectedProfile, selectedOrgao } = useAuthProvider();
  const history = useHistory();
  const isMobile = useBreakpointValue({ base: true, md: false });
  const [hintPreliminar, setHintPreliminar] = useState(false);
  const placement = useBreakpointValue({ md: "right" });
  const [loadingExcel, setLoadingExcel] = useState(false);

  useEffect(() => {
    let ignore = false;
    const getDadosServicosAcolhimento = async () => {
      setLoading(true);

      await ServicoAcolhimentoService.pesquisarServicosAcolhimentoPendencias()
        .then((res) => {
          if (!ignore) setData(res.data);
        })
        .catch(() => {
          if (!ignore) setData([]);
        })
        .finally(() => {
          if (!ignore) setLoading(false);
        });
    };
    getDadosServicosAcolhimento();
    return () => {
      ignore = true;
    };
  }, [selectedProfile, selectedOrgao]);

  const columns = [
    {
      Header: "Nome",
      accessor: "nomeServicoAcolhimento",
      Cell: (props) => {
        const id = props.row.original.idServicoAcolhimento;
        return (
          <Flex h={"40px"} alignItems="center">
            {roleKeycloack &&
            roleKeycloack.includes(servicoAcolhimentoFunc.visualizar) ? (
              <Link
                wordBreak={"break-all"}
                title={props.value}
                as={ReactLink}
                to={"/servico-acolhimento/" + id}
              >
                <Text minWidth="250px">{props.value}</Text>
              </Link>
            ) : (
              <Text minWidth="250px">{props.value}</Text>
            )}
          </Flex>
        );
      },
    },
    {
      Header: "Status",
      accessor: "status",
      Cell: (props) => {
        return <Text>{props.value ?? ""}</Text>;
      },
    },
    {
      Header: "Telefone",
      accessor: "telefone",
      Cell: (props) => {
        return <Text>{props.value ?? "Não possui telefone"}</Text>;
      },
    },
    {
      Header: "Pendências",
      accessor: "descricaoTipoPendencia",
      Cell: (props) => {
        const pendencia = props?.value;
        const idAba = props?.row?.original?.idAba;
        const idTipoPendencia = props?.row?.original?.idTipoPendencia;
        const idServico = props?.row?.original?.idServicoAcolhimento;
        const idPJ = props?.row?.original?.idPessoaJuridica;

        return (
          <Link
            onClick={() => {
              handleVerifyRedirectPendenciaServico(
                idAba,
                idTipoPendencia,
                history,
                idServico,
                true,
                roleKeycloack,
                user,
                idPJ
              );
            }}
          >
            {pendencia ? pendencia : ""}
          </Link>
        );
      },
    },

    {
      Header: "Aba",
      accessor: "nomeAba",
      Cell: (props) => {
        return <Text>{props.value}</Text>;
      },
    },
  ];

  const renderizarVisitas = () => {
    if (isMobile)
      return (
        <PopoverGenero
          isOpen={hintPreliminar}
          setIsOpen={setHintPreliminar}
          flex={true}
          handleClick={() => setHintPreliminar(!hintPreliminar)}
          labelTextoGenero={
            "Será exibida uma lista de pendências relacionada aos serviços de acolhimento localizados na sua área de atuação."
          }
        />
      );

    return (
      <Tooltip
        label={
          "Será exibida uma lista de pendências relacionada aos serviços de acolhimento localizados na sua área de atuação."
        }
        fontSize="md"
        maxW="400px"
        textAlign={"justify"}
        placement={placement}
      >
        <span className="hint-tooltip">
          <Icon
            aria-label="Aviso de pendente"
            color="#6B6C71"
            as={IoHelpCircle}
            boxSize={{ base: "20px" }}
          />
        </span>
      </Tooltip>
    );
  };

  const getExportarExecelRelatorio = async () => {
    const tempObj = JSON.parse(sessionStorage.getItem("table-sa"));

    const valuesToSend = {
      dataReferencia: "",
      municipioId: 0,
      promocaoId: 0,
      servicoAtendimentoId: 0,
      tipoRelatorio: "LISTA_PENDENCIAS_SERVICO_ACOLHIMENTO",
      sortField: tempObj ? tempObj[0]?.id : "nomeServicoAcolhimento",
      sortType: tempObj ? (tempObj[0]?.desc ? "DESC" : "ASC") : "ASC",
    };

    try {
      setLoadingExcel(true);
      await RelatorioService.getExecelListaRelatorio(valuesToSend);
      Swal.fire({
        title: "Em processamento",
        html: `<div style="text-align: center;">Este relatório está sendo processado em segundo plano. <br /> Para acompanhar, verifique a sua fila de processamento localizado no <br /> menu lateral do sistema.</div>`,
        icon: "success",
        showCancelButton: true,
        confirmButtonColor: "#169499",
        cancelButtonColor: "#169499",
        confirmButtonText: "Ir para Fila de Processamento",
        cancelButtonText: "Fechar",
        width: "600px",
      }).then((result) => {
        if (result.isConfirmed) {
          history.push("/fila-processamento");
        }
      });
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingExcel(false);
    }
  };

  return (
    <Flex
      pt={"20px"}
      px={["5px", "30px"]}
      h="100%"
      flexDir="column"
      w="100%"
      maxW="2000px"
      overflow="auto"
      pb={["10px", "20px"]}
    >
      <Group
        title={
          <Flex>
            <Text textTransform="uppercase">
              Pendências Serviço de Acolhimento
            </Text>

            {roleKeycloack?.includes(
              servicoAcolhimentoFunc.visualizarParteMP
            ) && <> {renderizarVisitas()} </>}
          </Flex>
        }
        opcoes={true}
        voltar={true}
      >
        <Permission
          roleKeycloack={roleKeycloack}
          func={dashboardFunc.dashboardPendenciasServicoExportar}
        >
          <Flex
            mt={6}
            alignItems="center"
            justifyContent="end"
            gap={2}
            cursor="pointer"
            onClick={() => !loadingExcel && getExportarExecelRelatorio()}
          >
            {loadingExcel ? (
              <Spinner size="sm" />
            ) : (
              <>
                <Flex bg="#006400" rounded="full" p={1}>
                  <RiFileExcel2Line color="white" />
                </Flex>

                <Text as="b" color="#006400" fontSize={"md"}>
                  Exportar em Excel
                </Text>
              </>
            )}
          </Flex>
        </Permission>

        {!loading ? (
          <>
            {data && data.length > 0 ? (
              <TableSA
                data={data}
                columns={columns}
                loading={loading}
                entidade="servico-acolhimento"
                roleKeycloack={roleKeycloack}
                disableHeaderOptionsOpcoes
              />
            ) : (
              <Box>
                <SemRegistros half buttonVisible={true} />
              </Box>
            )}
          </>
        ) : (
          <Box mt={4}>
            <LoadingSpinner />
          </Box>
        )}
      </Group>
    </Flex>
  );
}
